import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../axiosInstance.js';
import {SideBar} from "../SideBar/SideBar.js";

const MapVideoPanel = () => {
  const [videos, setVideos] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch videos from the backend
    const fetchVideos = async () => {
      try {
        const response = await axiosInstance.get('/map/content');
        setVideos(response.data);
      } catch (error) {
        console.error('Error fetching videos:', error);
        setErrorMessage('Failed to fetch videos');
      }
    };

    fetchVideos();
  }, []);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setSelectedFile(selectedFile);
    setSelectedVideo(URL.createObjectURL(selectedFile));
  };

  const handleVideoSelect = (index) => {
    setSelectedIndex(index);
    setSelectedVideo(videos[index].Video);
  };

  const handleSubmit = async () => {
    try {
      if (!selectedFile) {
        setErrorMessage('Please select a video file to update.');
        return;
      }

      setIsLoading(true);
      const formData = new FormData();
      formData.append('Video', selectedFile);

      const id = videos[selectedIndex]._id;
      const response = await axiosInstance.put(`/map/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      setIsLoading(false);
      setSelectedFile(null);
      setSelectedVideo(null);
      setSelectedIndex(null);
      setErrorMessage('');

      // Update the video list after successful update
      const updatedVideos = [...videos];
      updatedVideos[selectedIndex] = response.data;
      setVideos(updatedVideos);

      console.log('Service video updated successfully:', response.data);
    } catch (error) {
      setIsLoading(false);
      setErrorMessage('Failed to update map video. Please try again.');
      console.error('Error updating map video:', error);
    }
  };
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className="flex">
    <SideBar />

    <div className="flex-1 p-6 overflow-auto bg-gray-100">
    <div className="max-w-3xl mx-auto panel-container">
    <div className="panel-form bg-white p-8 rounded-lg shadow-xl">


      <h2 className="admin-nav-heading text-2xl font-semibold mb-6 text-gray-800">Update Service Video</h2>
      <div>
        <h3>Select a video to edit</h3>
        <ul>
          {videos.map((video, index) => (
            <li key={video._id}>
              <button                  className="px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors duration-300"  
 onClick={() => handleVideoSelect(index)}>
                {`Video ${index + 1}`}
              </button>
            </li>
          ))}
        </ul>
      </div>
      {selectedVideo && (
        <div>
          <h3>Selected Video</h3>
          <video controls width="300">
            <source src={selectedVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      )}
      <input               className="w-full p-4  border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
 type="file" onChange={handleFileChange} />
      {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
      <button
                      className="px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors duration-300"  

        onClick={handleSubmit}
        disabled={!selectedFile || isLoading || selectedIndex === null}
      >
        {isLoading ? 'Updating...' : 'Update Video'}
      </button>
    </div>
    </div>
    </div>
    </div>
  );
};

export default MapVideoPanel;
